import React from "react";
import style from "./style.module.scss";
import Row from "./row";
import SkeletonRow from "../../../../../../../components/skeleton-loader/table/row";

const InterChangeTable = ({ data = [], loading }) => {
  const tableData = Array.isArray(data) ? data : [];
  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            {/* <th className={style.header_cell}></th> */}
            <th className={style.header_cell} style={{ width: "100px" }}>
              Date
            </th>
            <th className={style.header_cell}>IC Level</th>
            <th className={style.header_cell}>Card Type</th>
            <th className={style.header_cell}>MAS Description</th>
            <th className={style.header_cell}>Num Sales MTD</th>
            <th className={style.header_cell}>Sales Amount MTD</th>
            <th className={style.header_cell}>Num Sales YTD</th>
            <th className={style.header_cell}>Sales Amount YTD</th>
            <th className={style.header_cell}>Num Sales Qual</th>
            <th className={style.header_cell}>Sales Amount Qual</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow
                key={`batch-data-skeleton-row-${index}`}
                columnLength={10}
              />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="10" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            tableData.map((row, index) => <Row data={row} key={index} />)
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InterChangeTable;
